import { PRODUCTS, type ProductId } from '@/config/products';
import { getProductIconComponent } from '@/config/productIcons';

/** All Co-Taskr products on auth pages */
const LOGIN_PRODUCT_IDS: ProductId[] = ['pm', 'code', 'ship', 'lenc'];

export function AuthInlineProductPills() {
  const loginProducts = PRODUCTS.filter((p) => LOGIN_PRODUCT_IDS.includes(p.id));

  return (
    <div className="flex flex-wrap justify-center gap-1.5">
      {loginProducts.map((product) => {
        const Icon = getProductIconComponent(product.iconKey);

        return (
          <div
            key={product.id}
            className={`login-smart-pill login-smart-pill--compact ${product.pillClass} ${
              product.id !== 'pm' ? 'login-smart-pill--muted' : ''
            }`}
          >
            <span className={`login-smart-pill__icon ${product.pillIconColor}`}>
              <Icon className="h-3 w-3" aria-hidden />
            </span>
            <span className="login-smart-pill__label">{product.shortName}</span>
          </div>
        );
      })}
    </div>
  );
}

export default function LoginProductPills() {
  const loginProducts = PRODUCTS.filter((p) => LOGIN_PRODUCT_IDS.includes(p.id));

  return (
    <div className="login-product-stack pointer-events-none absolute bottom-6 right-4 flex flex-col items-end gap-1.5 sm:bottom-8 sm:right-5 lg:right-10">
      {loginProducts.map((product) => {
        const Icon = getProductIconComponent(product.iconKey);

        return (
          <div
            key={product.id}
            className={`login-product-chip-wrap login-product-chip-wrap--${product.id}`}
          >
            <div
              className={`login-smart-pill login-smart-pill--compact login-smart-pill--fixed ${product.pillClass} ${
                product.id !== 'pm' ? 'login-smart-pill--muted' : ''
              }`}
            >
              <span className={`login-smart-pill__icon ${product.pillIconColor}`}>
                <Icon className="h-3 w-3" aria-hidden />
              </span>
              <span className="login-smart-pill__label">{product.shortName}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
